import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlayCircleOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"play_circle_outline"}/>
}
